/* @flow */
import PeopleList from './PeopleList';

export default PeopleList;
